import axios from "axios";
import { cloneDeep } from "lodash";

/* -------------------- MODULE-LEVEL FLAG -------------------- */
// Used to prevent duplicate calls for slides
let isSlidesLoading = false;
let isSlidesLoaded = false;
let hasQueuedSlidesRefresh = false;

/* -------------------- INITIAL STATE -------------------- */
const INITIAL_STATE = {
  slides: [],
  count: 0,
  pendingCleanupCount: 0,
  loaded: false,
  loading: true,
};

/* -------------------- ACTION TYPES -------------------- */
const SET_IMAGE_SUCCESS = "SET_IMAGE_SUCCESS";
const SET_SLIDES = "SET_SLIDES";
const SET_CLEANUP_PENDING = "SET_CLEANUP_PENDING";

/* -------------------- ACTION CREATORS -------------------- */

const setImageSuccess = (img) => {
  return { type: SET_IMAGE_SUCCESS, payload: img };
};

const setSlides = (slides) => {
  return { type: SET_SLIDES, payload: slides };
};

const setCleanupPendingCount = (count) => ({
  type: SET_CLEANUP_PENDING,
  payload: count,
});

/* -------------------- ASYNC ACTION CREATORS -------------------- */
export const saveCroppedImage = (img) => {
  return (dispatch) => {
    //dispatch(fetchReportListBegin());
    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/app/saveCroppedImage`,
        {
          img,
        },
        {
          headers: {
            ClientToken: localStorage.getItem("clientToken"),
          },
        },
      )
      .then((response) => {
        let image = response.data.img;
        image.data = img.data;
        dispatch(setImageSuccess(image));
      })
      .catch((error) => {
        //dispatch(fetchReportListError(error));
      });
  };
};
export const updateSlidesOrder = (slides) => {
  return (dispatch) => {
    let serverSlides = cloneDeep(slides);
    dispatch(setSlides(slides));

    serverSlides.forEach((item) => {
      delete item.data;
    });
    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/app/updateSlides`,
        {
          slides: serverSlides,
        },
        {
          headers: {
            ClientToken: localStorage.getItem("clientToken"),
          },
        },
      )
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        //dispatch(fetchReportListError(error));
      });
  };
};
export const deleteSlides = (slides, item) => {
  return (dispatch) => {
    dispatch(setSlides(slides));
    let newSlides = cloneDeep(slides);
    newSlides.forEach((item) => {
      delete item.data;
    });
    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/app/deleteSlides`,
        {
          slides: newSlides,
          item,
        },
        {
          headers: {
            ClientToken: localStorage.getItem("clientToken"),
          },
        },
      )
      .then((response) => {
        //console.log(response);
        dispatch(
          setCleanupPendingCount(response.data.pendingCleanupCount || 0),
        );
      })
      .catch((error) => {
        //dispatch(fetchReportListError(error));
      });
  };
};

export const retryPPTCartBlobCleanup = () => {
  return (dispatch) =>
    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/app/retryPPTCartBlobCleanup`,
        {},
        {
          headers: {
            ClientToken: localStorage.getItem("clientToken"),
          },
        },
      )
      .then((response) => {
        dispatch(
          setCleanupPendingCount(response.data.pendingCleanupCount || 0),
        );
        return response.data;
      });
};
export const getSlides = (forceRefresh = false) => {
  return (dispatch) => {
    if (isSlidesLoading) {
      if (forceRefresh) {
        hasQueuedSlidesRefresh = true;
      }
      return;
    }
    if (!forceRefresh && isSlidesLoaded) {
      return;
    }
    isSlidesLoading = true;
    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/app/getSlides`,
        {
          // Add timestamp to prevent any potential caching
          _t: Date.now(),
        },
        {
          headers: {
            ClientToken: localStorage.getItem("clientToken"),
          },
        },
      )
      .then((response) => {
        isSlidesLoaded = true;
        dispatch(setSlides(response.data.slides));
        dispatch(
          setCleanupPendingCount(response.data.pendingCleanupCount || 0),
        );
        //dispatch(setImageSuccess(img));
      })
      .catch((error) => {
        console.error("[pptCartReducer] getSlides error:", error);
        //dispatch(fetchReportListError(error));
      })
      .finally(() => {
        isSlidesLoading = false;
        if (hasQueuedSlidesRefresh) {
          hasQueuedSlidesRefresh = false;
          dispatch(getSlides(true));
        }
      });
  };
};

// Fetches slides with full blob data for PowerPoint export
// Returns a Promise so we can await it before building the PPT
export const getSlidesForExport = () => {
  return axios
    .post(
      `${process.env.REACT_APP_BIGHORN_SERVER}/api/app/getSlidesForExport`,
      {},
      {
        headers: {
          ClientToken: localStorage.getItem("clientToken"),
        },
      },
    )
    .then((response) => {
      return response.data.slides;
    });
};

/* -------------------- REDUCER -------------------- */
const pptCartReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_IMAGE_SUCCESS:
      let newSlides = state.slides;

      newSlides.push(action.payload);

      return {
        ...state,
        slides: newSlides,
        loading: false,
        loaded: true,
        count: state.count + 1,
      };
    case SET_SLIDES:
      return {
        ...state,
        slides: action.payload,
        loaded: true,
        loading: false,
        count: action.payload.length,
      };
    case SET_CLEANUP_PENDING:
      return {
        ...state,
        pendingCleanupCount: action.payload,
      };
    default:
      return state;
  }
};

export default pptCartReducer;
